module.exports = __webpack_public_path__ + "static/media/london_getty_mobile_tablet.52c783da.jpg";